import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/forsport/images/logo-brand.svg';

export default function index() {
  return (
    <Image src={logo} w={['102px', null, 'unset']} mt={['8', null, 'unset']} />
  );
}
